import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { DataService } from '../modules/shared/services';
import { map, filter, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EncDecService } from '../modules/shared/services/encryption-decryption.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private dataService: DataService, 
    private router: Router,
    private encryptionService: EncDecService,
  ) {
  }

canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
  const requiredPermission = next.data?.['permission'];

  return this.dataService.permissionPresent$.pipe(
    filter((loaded) => loaded === true), // wait until permissions loaded
    take(1),
    map(() => {
      let currentUser = null;
      const encrypted  = sessionStorage.getItem('currentUser') || 'null';
      if (encrypted) {
        const decrypted = this.encryptionService.get(encrypted);
        currentUser = JSON.parse(decrypted);
      }

      if (!currentUser || !currentUser.permission) {
        this.router.navigate(['/forbidden']);
        return false;
      }

      const access = currentUser.permission[requiredPermission];
      if (access && access !== 'NP') {
        return true;
      }

      this.router.navigate(['/forbidden']);
      return false;
    })
  );
}
}
